var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3691,
    cy: 23.3691,
    r: 23.3691,
    fill: "#E9EDF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1221 23.3697L21.8297 31.0774L22.9165 29.9906L17.0741 24.1405H32.6205V22.599H17.0741L22.9165 16.7488L21.8297 15.662L14.1221 23.3697Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.90da94957ace68b5b85c05c54d343e38.svg";
export { ForwardRef as ReactComponent };